import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { addMobileAppsLink, clearAddMobileAppsLink } from 'redux/links/actions';

import { Input } from 'semantic-ui-react';

import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validator from 'validator';
import { fixURL } from 'utils/fixURL';

import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './AddMobileAppLinkForm.css';

const AddMobileAppLinkForm = props => {
  const {
    type,
    addMobileAppsLink,
    addMobileAppsLinkError,
    addMobileAppsLinkSuccess,
    clearAddMobileAppsLink,
    me,
  } = props;

  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState('');

  useEffect(() => {
    if (addMobileAppsLinkSuccess) {
      setCurrentValue('');
      clearAddMobileAppsLink();
    }
  }, [addMobileAppsLinkSuccess]);

  const _onSubmit = () => {
    addMobileAppsLink(type, fixURL(currentValue));
  };

  const _onChangeValue = event => {
    event.preventDefault();
    setCurrentValue(event.target.value);
  };

  const validationError = () => {
    if (currentValue) {
      if (!validator.isURL(currentValue, { allow_underscores: true })) {
        return t("Please enter a valid URL");
      }
    }
    return null;
  };

  const isPro = me && me.subscription && me.subscription.ff_mobile_app_links;

  return (
    <div className="add-mobile-app-link-form__component">
      <div className="wrapper">
        <div className="input-wrapper">
          <Input
            value={currentValue}
            placeholder={`${t("Paste")} ${type === 'ios' ? 'iOS' : 'Android'} ${t("App Link")}`}
            onChange={event => {
              _onChangeValue(event);
            }}
          />
          {validationError() &&
          <div className="errors">
            {validationError()}
          </div>
          }
        </div>
        <ProFeaturePlaceholder
          className="mobile-app-pro-placeholder"
          locked={
            me &&
            me.subscription &&
            !me.subscription.ff_mobile_app_links
          }
          placeholderContent={
            <div>
              {t("Mobile Apps links are available on the PRO plan.")}
            </div>
          }
        >
          <Button
            onClick={_onSubmit}
            disabled={!currentValue || validationError() || !isPro}
          >
            <div className={`icon ${type}`} />
            <div>{t("Add")} {type === 'ios' ? 'iOS' : 'Android'} {t("App Link")}</div>
          </Button>
        </ProFeaturePlaceholder>
      </div>

      {/* Server Errors */}
      {currentValue && addMobileAppsLinkError &&
        <CommonMessage
          error
          errors={addMobileAppsLinkError}
        />
      }
    </div>
  );
};

AddMobileAppLinkForm.propTypes = {
  addMobileAppsLink: PropTypes.func.isRequired,
  clearAddMobileAppsLink: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  addMobileAppsLinkError: PropTypes.object,
  addMobileAppsLinkSuccess: PropTypes.object,
  me: PropTypes.object,
};

AddMobileAppLinkForm.defaultProps = {
  addMobileAppsLinkError: null,
  addMobileAppsLinkSuccess: null,
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    addMobileAppsLinkSuccess: state.linksReducer.addMobileAppsLinkSuccess,
    addMobileAppsLinkError: state.linksReducer.addMobileAppsLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    addMobileAppsLink,
    clearAddMobileAppsLink,
  },
)(AddMobileAppLinkForm);
